define(["jquery"], function ($) {
  class FrontendEvents {
    constructor() {
      this.bindSearchClickEvent();
      this.bindKeywords();
    }

    bindSearchClickEvent() {
      const searchInput = document.getElementById("search");
      const searchHelper = document.getElementById("search_autocomplete");
      const searchOverlay = document.querySelector(".search.overlay");

      function handleEmptySearch() {
        const appendedDiv = document.getElementsByClassName("appended-div");

        if (!searchInput.value) {
          if (
            !searchHelper.classList.contains(
              "aligent-search-autocomplete--show-results",
            )
          ) {
            searchHelper.classList.add(
              "aligent-search-autocomplete--show-results",
              "fade-in-search-popup",
            );
            searchHelper.style.opacity = "0";
            setTimeout(() => {
              searchHelper.style.opacity = "1";
            }, 40);
          }

          for (let child of searchHelper.children) {
            if (!child.classList.contains("hide-appended-results")) {
              child.classList.add("hide-appended-results");
            }
          }

          appendedDiv[0]?.classList.remove("hide-appended-results");
        } else if (
          searchInput.value &&
          !appendedDiv[0]?.classList.contains("hide-appended-results")
        ) {
          for (let child of searchHelper.children) {
            if (child.classList.contains("hide-appended-results")) {
              child.classList.remove("hide-appended-results");
            }
          }

          appendedDiv[0].classList.add("hide-appended-results");
        }
      }

      function handleClickingOverlay() {
        searchOverlay.classList.remove("active");
        searchHelper.classList.remove(
          "aligent-search-autocomplete--show-results",
          "fade-in-search-popup",
        );
        searchHelper.style.opacity = "0";
        searchInput.blur();
      }

      searchInput.addEventListener("focus", handleEmptySearch);
      searchInput.addEventListener("input", handleEmptySearch);
      searchOverlay.addEventListener("click", handleClickingOverlay);
    }

    bindKeywords() {
      const container = document.createElement("div");
      container.setAttribute(
        "class",
        "aligent-search-autocomplete__results appended-div hide-appended-results",
      );

      const keywordDiv = document.createElement("div");
      keywordDiv.setAttribute("class", "aligent-search-autocomplete__keywords");
      container.appendChild(keywordDiv);

      const trendingTitle = document.createElement("div");
      trendingTitle.setAttribute("class", "trending-title");
      trendingTitle.textContent = "TRENDING";
      keywordDiv.appendChild(trendingTitle);

      const ulElement = document.createElement("ul");
      ulElement.setAttribute(
        "class",
        "aligent-search-autocomplete__keywords-list",
      );
      keywordDiv.appendChild(ulElement);

      const formData = new FormData();
      formData.append("search", "-");

      $.ajax({
        url: `${window.location.origin}/datasource/fetch/suggestions`,
        type: "POST",
        data: formData,
        global: true,
        contentType: false,
        processData: false,
        headers: {},
        success: function (response) {
          const searchResults = response?.keywords;
          console.log(response);

          if (searchResults?.length > 0) {
            searchResults.forEach((keyword) => {
              console.log(keyword);
              const liElement = document.createElement("li");
              liElement.innerHTML = `
              <a href="/catalogsearch/result/?q=${keyword.searchterm.replace(" ", "%20")}">    
                ${keyword.searchterm} 
               </a>
            `;

              ulElement.appendChild(liElement);
            });
          }

          document.getElementById("search_autocomplete").appendChild(container);
        },
        error: function (error) {
          console.error("Error fetching product suggestions:", error);
        },
      });
    }
  }

  let instance = null;

  FrontendEvents.singleton = function () {
    if (!instance) {
      instance = new FrontendEvents();
    }
    return instance;
  };

  return FrontendEvents.singleton();
});
